export default __webpack_public_path__ + "static/media/course-sample3.4fa0f514.png";